// extracted by mini-css-extract-plugin
export default {"list":"PendientesLista_list__q+2GM"};